<app-create-page
  layout="stacked"
  [title]="'pages.settings.alerting.sources.create.title' | transloco"
  [subtitle]="'pages.settings.alerting.sources.create.subtitle' | transloco"
  icon="plugs"
  [backLabel]="'pages.settings.alerting.sources.create.back' | transloco"
  [backLink]="['/settings/alerting']">
  <a
    createPageAside
    [href]="docsUrl"
    target="_blank"
    rel="noopener"
    class="inline-flex items-center gap-2 rounded-md text-sm tracking-tight text-zinc-300 transition-colors duration-150 hover:text-zinc-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-50">
    <vx-icon name="question" size="md" />
    {{ 'pages.settings.alerting.sources.create.help.setup' | transloco }}
  </a>
  <a
    createPageAside
    [href]="contactUrl"
    target="_blank"
    rel="noopener"
    class="inline-flex items-center gap-2 rounded-md text-sm tracking-tight text-zinc-300 transition-colors duration-150 hover:text-zinc-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-50">
    <vx-icon name="chat-circle" size="md" />
    {{ 'pages.settings.alerting.sources.create.help.contact' | transloco }}
  </a>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
    <vx-card>
      <!-- mt-1.5: a header-less card has no top inset of its own, so the
           first panel mirrors the 6px the body gives the sides and bottom -->
      <vx-panel variant="group" class="mt-1.5">
        <div class="flex flex-col gap-4">
          <vx-form-field
            [label]="
              'pages.settings.alerting.sources.create.fields.name.label'
                | transloco
            ">
            <vx-input
              formControlName="name"
              autocomplete="off"
              [placeholder]="
                'pages.settings.alerting.sources.create.fields.name.placeholder'
                  | transloco
              " />
          </vx-form-field>

          <vx-form-field
            [label]="
              'pages.settings.alerting.sources.create.fields.type.label'
                | transloco
            ">
            <vx-select formControlName="type" [options]="typeOptions" />
          </vx-form-field>

          <vx-form-field
            [label]="
              'pages.settings.alerting.sources.create.fields.processor.label'
                | transloco
            "
            [hint]="
              'pages.settings.alerting.sources.create.fields.processor.hint'
                | transloco
            ">
            <vx-select
              formControlName="processorId"
              [options]="processorOptions()"
              [placeholder]="
                'pages.settings.alerting.sources.create.fields.processor.placeholder'
                  | transloco
              " />
          </vx-form-field>
        </div>
      </vx-panel>

      <vx-card-footer>
        <vx-button
          variant="ghost"
          tone="secondary"
          [routerLink]="['/settings/alerting']">
          {{ 'misc.cancelBtn' | transloco }}
        </vx-button>
        <span vxCardFooterActions [vRequiredRoles]="['alertsources.manager']">
          <!-- tooltip on the wrapper: a disabled button swallows pointer events -->
          <span [vxTooltip]="quotaTooltip()">
            <vx-button
              type="submit"
              [disabled]="!hasQuota()"
              [loading]="isSaving()">
              {{
                'pages.settings.alerting.sources.create.submitBtn' | transloco
              }}
            </vx-button>
          </span>
        </span>
      </vx-card-footer>
    </vx-card>
  </form>
</app-create-page>
